// extracted by mini-css-extract-plugin
export default {"layout":"ucE8APYN","content":"_IlfbPKv","loaderContainer":"RrmB7COb"};